import BallStrike from 'images/games/8-ball-strike/8_ball_strike.png'
import BingoTour from 'images/games/bingo-tour/bingo_tour.png'
import Gold2024 from 'images/games/gold_medal.png'
import Silver2024 from 'images/games/silver_medal.png'
import SolitaireLash from 'images/games/solitaire-clash/solitaire_lash.png'
import { StaticImageData } from 'next/image'
import { Awards, GameType } from './const'
import {
  BingoBlissEntity,
  BingoClashEntity,
  BingoTourEntity,
  BlockolotEntity,
  BubbleBuzzEntity,
  CashPoolEntity,
  DominoesEntity,
  DunkShotEntity,
  EightBallStrikeEntity,
  MatchNFlipEntity,
  NumbersBlitzEntity,
  PlaySolitaireOnlineEntity,
  Pocket7GamesEntity,
  PoolClashEntity,
  SolitaireClashEntity,
  SolitaireInfiniteEntity,
  SolitaireSlamEntity,
  SolitaireVentureEntity,
  TileBlitzEntity,
  TwentyOneGoldEntity,
} from './entity'

import { GameEntity } from './types'

export const GameTopTitle = 'Quick to Play, Quick to Win'
export const GameListTitle = 'ALL GAMES'

export const GameAwardsMap = {
  [Awards.Gold2024]: {
    logo: Gold2024,
  },
  [Awards.Silver2024]: {
    logo: Silver2024,
  },
}

export const AwardGames: Record<string, Awards> = {
  [GameType.SolitaireClash]: Awards.Gold2024,
  [GameType.BingoClash]: Awards.Silver2024,
  [GameType.EightBallStrike]: Awards.Gold2024,
  [GameType.SolitaireVenture]: Awards.Silver2024,
}

export const GameResourceList = [
  SolitaireClashEntity,
  BingoClashEntity,
  BingoTourEntity,
  EightBallStrikeEntity,
  SolitaireVentureEntity,
  Pocket7GamesEntity,
  BlockolotEntity,
  BubbleBuzzEntity,
  CashPoolEntity,
  SolitaireInfiniteEntity,
  SolitaireSlamEntity,
  BingoBlissEntity,
  MatchNFlipEntity,
  PlaySolitaireOnlineEntity,
  TwentyOneGoldEntity,
  TileBlitzEntity,
  NumbersBlitzEntity,
  PoolClashEntity,
  DunkShotEntity,
  DominoesEntity,
]

export const Games2Select = GameResourceList.slice(0, 12)

export const GamesNameMap = Object.fromEntries(Games2Select.map((item) => [item.key, item.title]))

export const GamesSwiperList: (GameEntity & { image: StaticImageData })[] = [
  {
    ...SolitaireClashEntity,
    image: SolitaireLash,
    description:
      'Love solitaire games? Try Solitaire Clash, the best free solitaire app that lets you win real cash! Play classic Klondike solitaire, compete in multiplayer tournaments, and join exciting minigames. With seamless gameplay, rewarding events, and high-score challenges, there’s always a way to win. Download now and start stacking cards—and cash!',
  },
  {
    ...BingoTourEntity,
    image: BingoTour,
    description:
      'Test your skills in Bingo Tour, where classic bingo games turn into thrilling competitions! Use strategic Power-Ups, daub fast, and rack up points to claim real cash! With exciting events, compelling challenges, and skill-based matchups, the fun never stops. Download now and start winning!',
  },
  {
    ...EightBallStrikeEntity,
    image: BallStrike,
    description:
      'Step up, pool sharks—it’s time to dominate the table! 8 Ball Strike delivers slick, high-stakes billiards action where every shot counts. Compete in cash matches, outplay opponents, and win real money in skill-based tournaments. Precision, power, and strategy will make you a legend. Download now and break big!',
  },
]

export const GameConclusions = [
  [
    {
      value: 'Avia is the go-to destination for casual, ',
    },
    {
      value: 'skill-based competitive gaming, and the publisher of top-ranking mobile games including ',
      isYellow: true,
    },
    {
      value: '“Solitaire Clash,” “Bingo Tour,” “Bingo Clash,” and ',
    },
    {
      value: 'the all-in-one platform, ',
      isYellow: true,
    },
    {
      value:
        'Pocket7Games. Quick to play and quick to win, Avia mobile games are fun, easily accessible and designed to unleash the competitive spirit in players of all skill levels. ',
    },
  ],
  [
    {
      value:
        'Avia offers over 15 unique, skill-based games, allowing players to seamlessly switch among a range of puzzle, action, card, math, and board games. Avia strives to bring endless excitement to millions of players around the world with its world-class entertainment and competition platform.',
    },
  ],
]

const Logos = GameResourceList.map(({ logo }) => logo)

export const SlideRowsList = [
  Logos,
  Logos.slice().reverse(),
  [
    SolitaireSlamEntity.logo,
    BingoBlissEntity.logo,
    MatchNFlipEntity.logo,
    PlaySolitaireOnlineEntity.logo,
    TwentyOneGoldEntity.logo,
    TileBlitzEntity.logo,
    NumbersBlitzEntity.logo,
    PoolClashEntity.logo,
    DunkShotEntity.logo,
    DominoesEntity.logo,
    SolitaireClashEntity.logo,
    BingoClashEntity.logo,
    BingoTourEntity.logo,
    EightBallStrikeEntity.logo,
    SolitaireVentureEntity.logo,
    Pocket7GamesEntity.logo,
    BlockolotEntity.logo,
    BubbleBuzzEntity.logo,
    CashPoolEntity.logo,
    SolitaireInfiniteEntity.logo,
  ],
]
